import { createContext } from '@picsart/miniapps-sdk';
import type { ICreateContextOptions, IGeneralContext } from '@picsart/miniapps-sdk/types/types';

type AppContextProvider = {
  getContext: () => IGeneralContext;
  destroyContext: () => void;
};

let appContext: null | AppContextProvider = null;

const setupContext = (options?: ICreateContextOptions) => {
  try {
    const result = createContext(options);

    if (!result || !result.getContext || !result.destroyContext) {
      return { unmount: () => {} };
    }

    appContext = result;

    return {
      unmount: () => {
        if (!appContext) {
          throw new Error('App context not initialized');
        }
        appContext.destroyContext();
      },
    };
  } catch (error) {
    console.warn('[Context] Failed to initialize SDK:', error);
    return { unmount: () => {} };
  }
};

const getContext = () => {
  if (!appContext) {
    throw new Error('App context not initialized');
  }
  return appContext.getContext();
};

const isContextAvailable = (): boolean => {
  return appContext !== null;
};

export { getContext, isContextAvailable };

export default setupContext;
